import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { handleChangeEmailInput } from "../../Inputs/handleKeyDown";
import axios from "axios";
import { domain } from "../../Links/Links";
import { getCookie } from "../../../App";
import { AuthContext } from "../../SessionChecker/SessionChecker";

function EmailConfirm({ theme }) {
  const [active, setActive] = useState(false);

  const { t } = useTranslation(); 

  const { setEmailConfirmStatus ,setCodeVerifStatus } = useContext(AuthContext);

  useEffect(() => {
    setActive(true);
  }, []);

  const [emailInputError, setEmailInputError] = useState(null);
  const [emailIsAvailable, setEmailIsAvailable] = useState(null);

  const [emailInputValue, setEmailInputValue] = useState(null);

  const [requestStatus, setRequestStatus] = useState(false);

  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setEmailConfirmStatus(false);
          }, 150);
        }}  
      ></div>
      <div className={`popupMainDiv noPadding ${theme} ${active && "active"}`}>
        <div className={`popupHeaderDiv ${theme}`}>{t("Confirm Email")}</div>
        <div className="popupContentDiv">
          <div className="inputDiv">
            <div className="labelDiv">{t("Email")}</div>
            <input
              type="email"
              className={`input ${theme}`}
              onChange={(e) => {
                handleChangeEmailInput(e.target.value, setEmailInputError);

                if (e.target.value.length == 0) {
                  setEmailInputError(false);
                }

                setEmailInputValue(e.target.value);

                EmailSearch(e.target.value, setEmailIsAvailable);
              }}
            ></input>

            {emailInputError == true && (
              <div className="inputErrorDiv">{t("Email is invalid")}</div>
            )}

            {emailIsAvailable == true && (
              <div className="inputErrorDiv">{t("Email is available")}</div>
            )}
            
          </div>

          <button
            className={`submitButton ${theme} ${emailInputError == false && emailIsAvailable == false && "active"} `}
            onClick={() => {
              if (emailInputError == false && emailIsAvailable == false) {
                EmailConfirmRequest(
                  emailInputValue,
                  setRequestStatus,
                  setActive,
                  setEmailConfirmStatus,
                  setCodeVerifStatus,
                );

                sessionStorage.setItem('email', emailInputValue);
              }
            }}
          >
            {requestStatus == true ? (
              <img src="/icons/loading.png" className={`rotate`}></img>
            ) : (
              t("Next")
            )}
          </button>

          

          
        </div>
      </div>
    </>
  );
}

export default EmailConfirm;

export async function EmailConfirmRequest(
  email,
  setRequestStatus,
  setActive,
  setEmailConfirmStatus,
  setCodeVerifStatus,
) {
  setRequestStatus(true);
  const response = await axios.post(
    domain + "/email_confirm/",
    { email: email },
    {
      withCredentials: true,
      headers: {
        "X-CSRFToken": getCookie("csrf_token"),
      },
    },
  );

  if (response.data) {
    setRequestStatus(false);
  }

  if (response.data.success == true) {
    
    setActive(false);
    setTimeout(() => {
      setEmailConfirmStatus(false);
      setCodeVerifStatus(true);
    }, 150);

  } else {
  }
}


async function EmailSearch(email, setEmailIsAvailable) {
    const response = await axios.get(domain + '/email_search/?email=' + email, {
        withCredentials: true,
    }) 

    console.log(response.data)

    if (response.data.available) {
        setEmailIsAvailable(true);
    } else if (response.data.not_available) {
        setEmailIsAvailable(false);

    }
}